import { UserList } from 'components/user/user-list/UserList'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
    constructOptionFilter,
    downloadFile,
    getAllQueryParams,
    getObjectName,
    isEmptyObject,
    setQueryParams,
} from 'utils/utils'
import { FILTER_PARAMS, FILTER_USER, INIT_STATUS, INITIAL_DATA_FILTER } from 'configs/user/configTableUserList'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import moment from 'moment'
import { Alert } from 'avo-ui'

const INIT_FILTER = {
    role_ids: [],
    status: [],
    membership_status: [],
}

export const UserListContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const [queryFilter, setQueryFilter] = useState(INIT_FILTER)
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [selectedIds, setSelectedIds] = useState([])
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState(INIT_STATUS[0])
    const [modalMessage, setModalMessage] = useState('')
    const [modal, setModal] = useState({
        filter: false,
        export: false,
        confirm: false,
        delete: false,
    })
    const { data: userList, fetching: getUserListApi, isLoading } = useFetch(API_USER.LIST)
    const { fetching: getRoleListApi } = useFetch(API_USER.ROLE_LIST)
    const { fetching: changeBulkStatusApi } = useFetch(API_USER.BULK_CHANGE_STATUS)
    const { fetching: exportUserListApi } = useFetch(API_USER.EXPORT)

    useEffect(() => {
        if (modal?.filter) {
            getRoleListApi().then((response) => {
                FILTER_USER[0].list = constructOptionFilter(response?.data, null, 'id')
            })
        }
    }, [modal?.filter])

    useEffect(() => {
        fetchUserList()
    }, [location?.search])

    const fetchUserList = () => {
        let newQueryFilter = {}
        Object.entries(query).forEach(([key, item]) => {
            if (FILTER_PARAMS.includes(key)) {
                newQueryFilter[key] = item?.split(',')
            }
        })

        setQueryFilter(isEmptyObject(newQueryFilter) ? INIT_FILTER : { ...queryFilter, ...newQueryFilter })
        getUserListApi({ ...query, ...newQueryFilter })
    }

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'start_date', 'role_ids'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('-')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    const onExport = () => {
        const payload = { user_ids: selectedIds, ...query, ...queryFilter }
        exportUserListApi(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `User-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowModal({ export: false })
        })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onApply = () => {
        if (selectedStatus?.value === INIT_STATUS[2].value) {
            setModalMessage('Are You Sure to Delete User?')
            setShowModal({ delete: true })
        } else {
            setModalMessage(`Are You Sure to Change User Status to ${selectedStatus?.label}?`)
            setShowModal({ confirm: true })
        }
    }

    const confirmBulkActionHandler = async (modalType) => {
        await changeBulkStatusApi({ action: selectedStatus.value, user_ids: selectedIds })
        selectedStatus?.value === 'delete' && setIsResetSelectedItem(!isResetSelectedItem)
        setShowModal({ [modalType]: false })
        fetchUserList()
        return Alert({
            icon: 'success',
            title: 'Success',
            message: 'Status Changed !',
        })
    }

    const props = {
        dataList: userList?.data,
        modal,
        setShowModal,
        onSelectSort,
        query,
        onChangeQuery,
        queryFilter,
        selectedIds,
        selectedStatus,
        onApply,
        modalMessage,
        onExport,
        setSelectedStatus,
        onSelectItemHandler,
        isLoading,
        confirmBulkActionHandler,
        isResetSelectedItem,
    }

    return <UserList {...props} />
}
